import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { faStar as faStarSolid } from '@fortawesome/free-solid-svg-icons';
import { faStar as faStarHollow } from '@fortawesome/free-regular-svg-icons';
import { faFacebookSquare, faTwitter } from '@fortawesome/free-brands-svg-icons'
import { faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { DetailsService } from 'src/app/services/details.service';
import { MatTabChangeEvent } from '@angular/material/tabs';
import * as Highcharts from 'highcharts';
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { timer } from 'rxjs';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.css']
})
export class DetailsComponent implements OnInit {
  timerSubscriber;

  detailsSpinnerDisplay: string = "inline";
  allDetailsStyleDisplay: string = "none";

  ticker: string;
  faStar = faStarHollow;
  faCaret = faCaretUp;
  faStarColor = "#000000";
  recentlyPutWatchlistMessage: string = "";
  recentlyRemovedWatchlistMessage: string = "";
  recentlyRemovedWatchlistMessageDisplay: string = "none";
  recentlyPutWatchlistMessageDisplay: string = "none";

  tickerValue: string;
  stockName: string;
  lastStockPrice: any = 0;
  exchangeCode: string;
  stockValueChange: any;
  stockValueChangePercent: any;
  stockPriceColor: any = "black";
  caretVisibility: any = "visible";
  timestamp: any;
  buyQuantity: number;
  currentPrice: any = 0;
  totalPrice: any = 0;
  buyButtonDisabled: boolean = true;
  boughtSuccessfullyMessageDisplay: string = "none";
  boughtSuccessfullyMessage: string = "";

  buyQuantityChange(event) {
    this.buyQuantity = Number.parseFloat(event.target.value);
    this.totalPrice = (this.currentPrice * event.target.value).toFixed(2);
    console.log(this.totalPrice);
    this.buyButtonDisabled = this.buyQuantity <= 0;
  }

  marketStatusBackgroundColor: string = "";
  marketStatusTextColor: string = "";
  marketStatusText: string = "";
  marketStatusBasedDisplayValue: string = "";
  highPrice: any;
  midPrice: any;
  lowPrice: any;
  askPrice: any;
  openPrice: any;
  askSize: any;
  prevClose: any;
  bidPrice: any;
  volume: any;
  bidSize: any;

  startDate: any;
  description: string;

  Highcharts: typeof Highcharts = Highcharts;
  dailyChartOptions: Highcharts.Options = {
    series: [{
      data: [1, 2, 3],
      type: 'line'
    }]
  };

  topnews: any[];

  modalHeading: string = "";
  modalDate: string = "";
  modalTitle: string = "";
  modalDescription: string = "";
  modalHyperlink: string = "";
  modalTwitterShareURL: string = "";
  modalFacebookShareURL: string = "";
  faFacebook = faFacebookSquare;
  faTwitter = faTwitter;

  constructor(private route: ActivatedRoute, private detailsService: DetailsService, private modalService: NgbModal) { }

  setCommonDetails(RESTResponse: any) {
    this.tickerValue = RESTResponse["description"]["ticker"];
    this.stockName = RESTResponse["description"]["name"];
    this.lastStockPrice = (RESTResponse["latest_price"][0]["last"]).toFixed(2);

    this.stockValueChange = (RESTResponse["latest_price"][0]["last"] - RESTResponse["latest_price"][0]["prevClose"]).toFixed(2);
    this.stockValueChangePercent = ((this.stockValueChange / RESTResponse["latest_price"][0]["prevClose"]) * 100).toFixed(2);

    this.faCaret = this.stockValueChange < 0 ? faCaretDown : faCaretUp;
    if (this.stockValueChange < 0) {
      this.stockPriceColor = "red";
      this.faCaret = faCaretDown;
      this.caretVisibility = "visible";
    } else if (this.stockValueChange > 0) {
      this.stockPriceColor = "green";
      this.faCaret = faCaretUp;
      this.caretVisibility = "visible";
    } else {
      this.stockPriceColor = "black";
      this.caretVisibility = "hidden";
    }

    this.exchangeCode = (RESTResponse["description"]["exchangeCode"]);
    let todaysDate = new Date();
    this.timestamp = todaysDate.getFullYear() + "-" + ("0" + (todaysDate.getMonth() + 1)).slice(-2) + "-" + ("0" + todaysDate.getDate()).slice(-2) + " " + ("0" + todaysDate.getHours()).slice(-2) + ":" + ("0" + todaysDate.getMinutes()).slice(-2) + ":" + ("0" + todaysDate.getSeconds()).slice(-2);
  }

  setSummaryDetails(RESTResponse) {
    let timestamp = new Date(RESTResponse["latest_price"][0]["timestamp"]);
    let timestampString = timestamp.getFullYear() + "-" + ("0" + (timestamp.getMonth() + 1)).slice(-2) + "-" + ("0" + timestamp.getDate()).slice(-2) + " " + ("0" + timestamp.getHours()).slice(-2) + ":" + ("0" + timestamp.getMinutes()).slice(-2) + ":" + ("0" + timestamp.getSeconds()).slice(-2);

    if (RESTResponse["latest_price"][0]["bidPrice"] == null &&
      RESTResponse["latest_price"][0]["bidSize"] == null &&
      RESTResponse["latest_price"][0]["askPrice"] == null &&
      RESTResponse["latest_price"][0]["askSize"] == null) {
      this.marketStatusBackgroundColor = "#F8D8E0";
      this.marketStatusTextColor = "black";
      this.marketStatusText = 'Market Closed on ' + timestampString;
      this.marketStatusBasedDisplayValue = "none";
      this.currentPrice = RESTResponse["latest_price"][0]["prevClose"];
    } else {
      this.marketStatusBackgroundColor = "green";
      this.marketStatusTextColor = "white";
      this.marketStatusText = 'Market is Open';
      this.marketStatusBasedDisplayValue = "inline";
      this.currentPrice = RESTResponse["latest_price"][0]["last"];
    }

    this.highPrice = RESTResponse["latest_price"][0]["high"];
    this.midPrice = RESTResponse["latest_price"][0]["mid"] === null ? "-" : RESTResponse["latest_price"][0]["mid"];
    this.lowPrice = RESTResponse["latest_price"][0]["low"];
    this.askPrice = RESTResponse["latest_price"][0]["askPrice"];
    this.openPrice = RESTResponse["latest_price"][0]["open"];
    this.askSize = RESTResponse["latest_price"][0]["askSize"];
    this.prevClose = RESTResponse["latest_price"][0]["prevClose"];
    this.bidPrice = RESTResponse["latest_price"][0]["bidPrice"];
    this.volume = RESTResponse["latest_price"][0]["volume"];
    this.bidSize = RESTResponse["latest_price"][0]["bidSize"];

    this.startDate = RESTResponse["description"]["startDate"];
    this.description = RESTResponse["description"]["description"];

    var date_close_stock_price_array = RESTResponse["last_working_day_stock_values"].map(record => {
      let dt = new Date(record["date"]);
      return [Date.UTC(dt.getFullYear(), dt.getMonth(), dt.getDate(), dt.getHours(), dt.getMinutes(), dt.getSeconds()), record["close"]]
    });

    this.dailyChartOptions = {
      title: {
        text: RESTResponse["description"]["ticker"].toUpperCase()
      },
      xAxis: {
        "startOnTick": true,
        type: 'datetime',
        tickInterval: 1800 * 1000,
        tickPositioner: function () {
          return this.tickPositions.map(x => x -= 1800 * 1000);
        },
        labels: {
          format: '{value:%H:%M}'
        }
      },
      tooltip: {
        split: true
      },
      plotOptions: {
        line: { marker: { enabled: false } }
      },
      yAxis: {
        opposite: true,
        title: {
          text: ''
        }
      },
      series: [
        {
          type: 'line',
          showInLegend: false,
          data: date_close_stock_price_array,
          name: RESTResponse["description"]["ticker"].toUpperCase(),
          yAxis: 0,
          tooltip: {
            valueDecimals: 2
          },
          color: (this.stockValueChange < 0 ? 'red' : '#4F7E37')
        }]
    };
  }

  setNewsDetails(RESTResponse) {
    let news = RESTResponse["news"]["articles"].filter(article =>
      article["title"] !== undefined && article["title"] !== null && article["title"].length > 0 && article["title"]
      && article["url"] !== undefined && article["url"] !== null && article["url"].length > 0 && article["url"]
      && article["urlToImage"] !== undefined && article["urlToImage"] !== null && article["urlToImage"].length > 0 && article["urlToImage"]
      && article["source"] !== undefined && article["source"] !== null && Object.keys(article["source"]).length > 0 && article["source"]
      && article["description"] !== undefined && article["description"] !== null && article["description"].length > 0 && article["description"]
      && article["publishedAt"] !== undefined && article["publishedAt"] !== null && article["publishedAt"].length > 0 && article["publishedAt"]);

    let finalnews = [];
    for (let index = 0; index < news.length; index += 2)
      finalnews.push(news.slice(index, 2 + index));

    if (finalnews[finalnews.length - 1].length == 1)
      finalnews[finalnews.length - 1].push({ title: undefined, urlToImage: undefined })

    console.log(finalnews);

    this.topnews = finalnews;
  }

  tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
    if (tabChangeEvent.index === 0)       // Summary
    {
      this.detailsService.getTickerSummary(this.ticker).subscribe(summaryRESTResponse => {
        this.setCommonDetails(summaryRESTResponse);
        this.setSummaryDetails(summaryRESTResponse);
      });
    } else if (tabChangeEvent.index === 1)  // Top News
    {
      this.detailsService.getTickerNews(this.ticker).subscribe(newsRESTResponse => {
        this.setCommonDetails(newsRESTResponse);
        this.setNewsDetails(newsRESTResponse);
      });
    } else if (tabChangeEvent.index === 2)  // Charts
    {
      this.detailsService.getTickerCharts(this.ticker).subscribe(chartsRESTResponse => {
        this.setCommonDetails(chartsRESTResponse);
        //chart details handled individually by another component
      });
    }
  }

  changeStarFavoriteClick() {
    let watchlist: any = localStorage.getItem("ritesht_watchlist_stocks");
    if (watchlist) {
      watchlist = JSON.parse(watchlist);
      watchlist[this.ticker] = !watchlist[this.ticker];

      if (watchlist[this.ticker]) {
        this.recentlyPutWatchlistMessage = this.ticker + " added to Watchlist";
        this.recentlyPutWatchlistMessageDisplay = "inline";
        setTimeout(() => this.recentlyPutWatchlistMessageDisplay = "none", 2000);
      } else {
        this.recentlyRemovedWatchlistMessage = this.ticker + " removed from Watchlist";
        this.recentlyRemovedWatchlistMessageDisplay = "inline";
        setTimeout(() => this.recentlyRemovedWatchlistMessageDisplay = "none", 2000);
      }
    } else {
      watchlist = {}
      watchlist[this.ticker] = true;
      this.recentlyPutWatchlistMessage = this.ticker + " added to Watchlist";
      this.recentlyPutWatchlistMessageDisplay = "inline";
      setTimeout(() => this.recentlyPutWatchlistMessageDisplay = "none", 2500);
    }
    localStorage.setItem("ritesht_watchlist_stocks", JSON.stringify(watchlist))
    let temp: any = localStorage.getItem("ritesht_watchlist_stock_names");
    if (temp != null && temp != undefined)
      temp = JSON.parse(temp);
    else
      temp = {};
    temp["" + this.ticker] = this.stockName;
    localStorage.setItem("ritesht_watchlist_stock_names", JSON.stringify(temp));
    this.readAndSetStarFavoriteClick();
  }

  readAndSetStarFavoriteClick() {
    let watchlist: any = localStorage.getItem("ritesht_watchlist_stocks");
    if (watchlist) {
      watchlist = JSON.parse(watchlist);
      if (watchlist[this.ticker]) {
        this.faStar = faStarSolid;
        this.faStarColor = "#FFD500";
      } else {
        this.faStar = faStarHollow;
        this.faStarColor = "#000000";
      }
    } else {
      this.faStar = faStarHollow;
      this.faStarColor = "#000000";
    }

    setTimeout(() => {
      this.detailsSpinnerDisplay = "none";
      this.allDetailsStyleDisplay = "inline";
    }, 1500);
  }

  onNewsItemClicked(content, news) {
    this.modalHeading = news["source"]["name"];
    let publishedAtDate = new Date(news["publishedAt"]);
    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    this.modalDate = monthNames[publishedAtDate.getMonth()] + " " + publishedAtDate.getDate() + ", " + publishedAtDate.getFullYear();
    this.modalTitle = news["title"];
    this.modalDescription = news["description"];
    this.modalHyperlink = news["url"];
    this.modalTwitterShareURL = encodeURI("http://twitter.com/share?text=" + news["title"] + "&url=" + news["url"])
    this.modalFacebookShareURL = encodeURI("https://www.facebook.com/sharer/sharer.php?u=" + news["url"])
    this.modalService
      .open(content, { ariaLabelledBy: "modal-basic-title" })
      .result.then(
        result => {

        },
        reason => {

        }
      );
  }

  onBuyClicked(buycontent) {
    this.modalService
      .open(buycontent, { ariaLabelledBy: "modal-basic-title" })
      .result.then(
        result => {
          console.log("Buy clicked");

          let portfolio: any = localStorage.getItem("ritesht_portfolio")
          if (portfolio !== null && portfolio !== undefined) {
            portfolio = JSON.parse(portfolio);
            if (portfolio[this.ticker])
              portfolio[this.ticker] = [this.stockName, (portfolio[this.ticker][1] ? Number.parseFloat(portfolio[this.ticker][1]) : 0) + this.buyQuantity, portfolio[this.ticker][2] + Number.parseFloat(this.totalPrice)];
            else
              portfolio[this.ticker] = [this.stockName, this.buyQuantity, Number.parseFloat(this.totalPrice)];
          } else {
            portfolio = {};
            portfolio[this.ticker] = [this.stockName, this.buyQuantity, Number.parseFloat(this.totalPrice)];
          }
          localStorage.setItem("ritesht_portfolio", JSON.stringify(portfolio));
          console.log(portfolio);

          this.recentlyPutWatchlistMessage = this.ticker + " bought successfully!";
          this.recentlyPutWatchlistMessageDisplay = "inline";
          setTimeout(() => this.recentlyPutWatchlistMessageDisplay = "none", 2500);

          this.buyQuantity = 0;
          this.totalPrice = 0;
          this.buyButtonDisabled = true;
        },
        reason => {
          console.log("Buy not clicked");

          this.buyQuantity = 0;
          this.totalPrice = 0;
          this.buyButtonDisabled = true;
        }
      );
  }

  ngOnInit(): void {
    this.ticker = this.route.snapshot.paramMap.get('ticker');

    this.detailsService.getTickerSummary(this.ticker).subscribe(summaryRESTResponse => {
      console.log("Summary Response: ", summaryRESTResponse);
      this.setCommonDetails(summaryRESTResponse);
      this.setSummaryDetails(summaryRESTResponse);
    });

    this.readAndSetStarFavoriteClick();

    this.timerSubscriber = timer(15000, 15000).subscribe(val => {
      console.log("doing 15 seconds refresh");
      this.detailsService.getTickerSummary(this.ticker).subscribe(summaryRESTResponse => {
        this.setCommonDetails(summaryRESTResponse);
        this.setSummaryDetails(summaryRESTResponse);
      });
      this.detailsService.getTickerNews(this.ticker).subscribe(newsRESTResponse => {
        this.setCommonDetails(newsRESTResponse);
        this.setNewsDetails(newsRESTResponse);
      });
    })
  }
}